import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatiqScreenErrorComponent } from './components';
import { DatiqIconsModule } from '@dat/datiq-components-pkg/icons';
import { MatIconModule } from '@angular/material/icon';
import { DatiqScreenDisabledComponent } from './components/datiq-screen-disabled/datiq-screen-disabled.component';
import { DatiqTemplateModule } from '@dat/datiq-components-pkg/template';
import { DatiqButtonModule } from '@dat/datiq-components-pkg/button';
import { DatiqScreenErrorEmbeddedComponent } from './components/datiq-screen-error-embedded/datiq-screen-error-embedded.component';

@NgModule({
    declarations: [
        DatiqScreenErrorComponent,
        DatiqScreenDisabledComponent,
        DatiqScreenErrorEmbeddedComponent,
    ],
    exports: [
        DatiqScreenErrorComponent,
        DatiqScreenDisabledComponent,
        DatiqScreenErrorEmbeddedComponent,
    ],
    imports: [
        CommonModule,
        DatiqIconsModule,
        MatIconModule,
        DatiqTemplateModule,
        DatiqButtonModule,
    ],
})
export class DatiqScreenModule {}
